import { Cushion, FlexContainer, Grid, MaxWidth, Shimmer, Space } from '@pitchero/react-ui';
import React from 'react';

const CalendarLoadingState = () => (
  <MaxWidth component="div" maxWidth={1366} center>
    <Space vertical="medium">
      <Cushion all="small" component="div">
        <Grid
          columns="1fr"
          rowGap="medium"
          columnGap="large"
          responsive={[
            { minWidth: 'fullHeader', props: { columns: 'minmax(0, 900px) minmax(0, 450px)' } },
          ]}
          style={{ padding: '20px 0' }}
        >
          <FlexContainer flexDirection="column" style={{ gap: '40px' }}>
            <Shimmer width="100%" height="80px" radius="rounded" />
            <Shimmer width="100%" height="400px" radius="rounded" />
          </FlexContainer>
          <div>
            <Shimmer width="100%" height="320px" radius="rounded" />
          </div>
        </Grid>
      </Cushion>
    </Space>
  </MaxWidth>
);

export default CalendarLoadingState;
